"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BareSignIn = exports.SignInType = exports.AvailableProvider = void 0;
var outline_1 = require("@heroicons/react/24/outline");
var solid_1 = require("@heroicons/react/24/solid");
var react_1 = __importStar(require("react"));
var logo_google_png_1 = __importDefault(require("../../../assets/logo_google.png"));
var button_1 = require("../../action/button");
var form_1 = require("../../input/form");
var textInput_1 = require("../../input/textInput");
var SignInType;
(function (SignInType) {
    SignInType["SIGNIN"] = "signIn";
    SignInType["RESETPASSWORD"] = "resetPassword";
})(SignInType = exports.SignInType || (exports.SignInType = {}));
var BareSignIn = /** @class */ (function (_super) {
    __extends(BareSignIn, _super);
    function BareSignIn() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formRef = (0, react_1.createRef)();
        _this.input1 = (0, react_1.createRef)();
        _this.input2 = (0, react_1.createRef)();
        _this.state = {
            type: SignInType.SIGNIN,
            email: "",
            password: "",
            phone: "",
            otp: "",
        };
        _this.handleComplete = function () {
            if (_this.props.onComplete) {
                _this.props.onComplete(JSON.parse(JSON.stringify(_this.state)));
            }
        };
        _this.handleChangeAuthType = function (value) {
            _this.setState({
                type: value,
            });
        };
        _this.handleChangeInput = function (e) {
            var _a;
            _this.setState((_a = {},
                _a[e.target.id] = e.target.value,
                _a));
        };
        _this.handleChangeProvider = function (provider) {
            _this.handleChangeAuthType(SignInType.SIGNIN);
            _this.props.onChangeProvider(provider);
        };
        _this.renderOtherProvidedContent = function () {
            var otherProviderList = [];
            _this.props.provider.map(function (eachProvider) {
                var _a;
                if (!_this.props.type.includes(eachProvider)) {
                    switch (eachProvider) {
                        case "email":
                            otherProviderList.push(react_1.default.createElement(button_1.Button, { type: "icon", key: eachProvider, className: "w-full", text: "Sign In With Email", onClick: _this.handleChangeProvider.bind(_this, "email"), icon: react_1.default.createElement(outline_1.EnvelopeIcon, { className: "h-6 w-6 mr-3" }) }));
                            break;
                        case "google":
                            otherProviderList.push(react_1.default.createElement(button_1.Button, { type: "icon", key: eachProvider, className: "w-full", text: "Sign In With Google", onClick: _this.props.onChangeProvider.bind(_this, "google"), icon: react_1.default.createElement("img", { src: (_a = _this.props.imgLogo) !== null && _a !== void 0 ? _a : logo_google_png_1.default, alt: "", className: "h-6 w-6 mr-3" }) }));
                            break;
                        case "phone":
                            otherProviderList.push(react_1.default.createElement(button_1.Button, { type: "icon", key: eachProvider, className: "w-full", text: "Sign In With Phone", onClick: _this.handleChangeProvider.bind(_this, "phone"), icon: react_1.default.createElement(outline_1.DevicePhoneMobileIcon, { className: "h-6 w-6 mr-3" }) }));
                            break;
                        default:
                            break;
                    }
                }
                return null;
            });
            return otherProviderList;
        };
        _this.renderContent = function () {
            var formClass = "mt-6 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8";
            if (_this.props.column === "flex") {
                formClass = "mt-6 flex flex-col gap-y-6";
            }
            var component;
            switch (_this.state.type) {
                case SignInType.SIGNIN:
                    component = _this.renderSignInContent();
                    break;
                case SignInType.RESETPASSWORD:
                    component = _this.renderResetPasswordContent();
                    break;
            }
            if (component) {
                return (react_1.default.createElement(form_1.Form, { className: formClass, refList: [_this.input1, _this.input2], ref: _this.formRef, handleComplete: _this.handleComplete }, component));
            }
            return null;
        };
        _this.renderResetPasswordContent = function () {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(textInput_1.TextInput, { ref: _this.input1, id: "email", value: _this.state.email, type: "email", label: "Email", placeholder: "hello@example.com", onChange: _this.handleChangeInput }),
                _this.renderAuthButton()));
        };
        _this.renderSignInContent = function () {
            switch (_this.props.type) {
                case "email":
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(textInput_1.TextInput, { ref: _this.input1, id: "email", value: _this.state.email, type: "email", label: "Email", placeholder: "hello@example.com", onChange: _this.handleChangeInput }),
                        react_1.default.createElement(textInput_1.TextInput, { ref: _this.input2, id: "password", value: _this.state.password, type: "password", label: "Password", placeholder: "******", onChange: _this.handleChangeInput }),
                        _this.renderAuthButton()));
                case "phone":
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(textInput_1.TextInput, { ref: _this.input1, id: "phone", value: _this.state.phone, type: "mobile", label: "Phone", mobilePicker: _this.props.mobilePicker, placeholder: "+60123456789", onChange: _this.handleChangeInput }),
                        react_1.default.createElement("div", { id: "recaptcha-container", className: "my-2 w-full" }),
                        _this.renderAuthButton()));
                case "phoneOTP":
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(textInput_1.TextInput, { ref: _this.input1, id: "otp", value: _this.state.otp, type: "regex", autoComplete: "off", label: "OTP Code", placeholder: "123456", onChange: _this.handleChangeInput, pattern: RegExp("^[0-9]{6,6}$") }),
                        _this.props.onChangeResendOTP && (react_1.default.createElement("div", null,
                            react_1.default.createElement("div", { id: "recaptcha-container", className: "my-2 w-full" }),
                            react_1.default.createElement("div", { className: "sm:col-span-2 sm:flex sm:justify-end" },
                                react_1.default.createElement(solid_1.ArrowPathIcon, { className: "w-5 h-5 mr-1 mt-1 text-primary-600" }),
                                react_1.default.createElement("span", { className: "text-base text-primary-600 cursor-pointer", onClick: _this.props.onChangeResendOTP }, "Resend OTP")))),
                        _this.renderAuthButton()));
                default:
                    return react_1.default.createElement(react_1.default.Fragment, null);
            }
        };
        _this.renderAuthButton = function () {
            var rememberText = _this.state.type === SignInType.SIGNIN
                ? "Forgot Your Password?"
                : "Remembered Your Password?";
            var buttonText = _this.state.type === SignInType.SIGNIN ? "Sign In" : "Reset Password";
            return (react_1.default.createElement(react_1.default.Fragment, null,
                _this.props.type === "email" && (react_1.default.createElement("div", { className: "sm:col-span-2 sm:flex sm:justify-end" },
                    react_1.default.createElement("span", { className: "text-base text-primary-600 cursor-pointer", onClick: _this.handleChangeAuthType.bind(_this, _this.state.type === SignInType.SIGNIN
                            ? SignInType.RESETPASSWORD
                            : SignInType.SIGNIN) }, rememberText))),
                react_1.default.createElement("div", { className: "justify-end sm:col-span-2 sm:flex sm:ml-8" },
                    react_1.default.createElement("div", { className: "hidden sm:block" }),
                    react_1.default.createElement(button_1.Button, { className: "w-full mt-4 sm:w-1/2", text: buttonText, size: "small", type: "normal", onClick: function () {
                            var _a;
                            (_a = _this.formRef.current) === null || _a === void 0 ? void 0 : _a.handleSubmit();
                        } }))));
        };
        return _this;
    }
    BareSignIn.prototype.render = function () {
        var defaultClassName = "";
        if (this.props.className) {
            defaultClassName += " ".concat(this.props.className);
        }
        return (react_1.default.createElement("div", { className: defaultClassName },
            this.renderContent(),
            react_1.default.createElement("div", { className: "mt-6 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8" },
                this.props.provider.length > 1 && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "flex flex-row items-center sm:col-span-2 mt-2" },
                        react_1.default.createElement("div", { className: "flex-grow border-t border-gray-300" }),
                        react_1.default.createElement("span", { className: "text-sm px-2 text-gray-500" }, "Or Continue With"),
                        react_1.default.createElement("div", { className: "flex-grow border-t border-gray-300" })),
                    this.props.provider.length <= 2 && (react_1.default.createElement("div", { className: "hidden sm:block" })),
                    this.renderOtherProvidedContent())),
                this.props.version && (react_1.default.createElement("div", { className: "sm:col-span-2 sm:flex sm:justify-end" },
                    react_1.default.createElement("span", { className: "text-xs text-gray-500" },
                        "Version ",
                        this.props.version))))));
    };
    return BareSignIn;
}(react_1.Component));
exports.BareSignIn = BareSignIn;
//# sourceMappingURL=index.js.map